<template>
  <article class="session">
    <!--
    <h2>{{session.name}}</h2>

    <button @click="reload">Reload</button>
    -->
    <div v-if="currentMotions" class="motions">
      <!--<motions-list :motions="currentMotions"/>-->
      <Carousel
        :autoplay="true"
        :loop="true"
        :per-page="1"
        :pagination-enabled="false"
        :autoplay-hover-pause="false"
        :autoplay-timeout="20000"
        :touch-drag="false"
        :mouse-drag="false"
        @page-change="onPageChange">
        <!--
        <Slide key="slide-list">
          <motions-list :motions="currentMotions"/>
        </Slide>
        -->
        <Slide v-for="motion in currentMotions" :key="motion.id">
          <motion-view :motion="motion" />
        </Slide>
      </Carousel>
    </div>

      <!--
      <progress-bar :value="pcSlideElapsed" :show-value="false"/>
      -->
    <!--
    <footer class="p-d-flex">
      <div class="flex-grow-1">
        <div v-if="nextMotion">
          Next: <strong>{{nextMotion.name}}</strong>
        </div>
      </div>
      <footer class="paging">
        {{slideNumber}} / {{numSlides}}
      </footer>
    </footer>
    -->
  </article>
</template>

<script>

import MotionView from '../motions/MotionView.vue'
import MotionsList from '../motions/MotionsList.vue'
import { Carousel, Slide } from 'vue-carousel'
import ProgressBar from 'primevue/progressbar'

export default {
  name: 'SessionView',
  components: {
    MotionView,
    MotionsList,
    Carousel,
    Slide,
    ProgressBar
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      currentMotions: null,
      slideTimer: null,
      slideTimeElapsed: 0,
      slideNumber: null
    }
  },
  computed: {
    motions () {
      return this.$store.getters['motions/forSession'](this.session)
    },
    pcSlideElapsed () {
      return (this.slideTimeElapsed / 30000) * 100
    },
    numSlides () {
      if (this.currentMotions == null) {
        return 0
      }
      return this.currentMotions.length + 1
    },
    nextMotion () {
      if (this.currentMotions == null) {
        return null
      }
      if (this.currentMotions.length <= 1) {
        return null
      }
      if (this.slideNumber === this.currentMotions.length + 1) {
        return this.currentMotions[0]
      }
      return this.currentMotions[this.slideNumber - 1]
    }
  },
  mounted () {
    this.currentMotions = [...this.motions]
    if (this.currentMotions.length > 0) {
      this.slideNumber = 1
    }
    this.slideTimer = setInterval(() => { this.slideTimeElapsed += 100 }, 100)
  },
  destroyed () {
    this.slideTimer = null
  },
  methods: {
    reload () {
      this.currentMotions = [...this.motions]
    },
    onPageChange (page) {
      this.slideTimeElapsed = 0
      this.slideNumber = page + 1
      if (page === (this.currentMotions.length - 1)) {
        this.currentMotions = [...this.motions]
      }
    }
  }
}
</script>

<style scoped>
.session {
  display: flex;
  flex-direction: column;
}
.motions {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/sessions/SessionView.vue